package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "es", default = false)
val EsStrings = Strings(
    analyzer = "Analizador",
    appreciationOverview = "Resumen de apreciación",
    chartLegendInterest = "Interés",
    chartLegendPrincipal = "Principal",
    chartXaxisMonths = "Meses",
    chartYaxisPayment = "Pago",
    code = "es",
    costOfCredit = "Costo del crédito",
    creditDealAnalyzerDescription = "Ingrese los detalles de su préstamo para recibir un análisis completo de su acuerdo de crédito. Nuestro analizador evalúa las métricas clave para ayudarlo a comprender el costo real de su préstamo y tomar una decisión informada.",
    detailsGoodRateLongTerm = "Buena tasa pero el largo plazo resulta en un alto costo total.",
    detailsHighApr = "TAE alta. ",
    detailsHighInterestCost = "Alto costo total de intereses.",
    detailsHighRateShortTerm = "Tasa alta pero el corto plazo mantiene bajo el costo total.",
    detailsLowApr = "TAE baja. ",
    detailsLowInterestCost = "Bajo costo total de intereses.",
    discountsTradeIn = "Descuentos / Entrega a cambio",
    displayName = "Español",
    distribution = "Distribución",
    downPayment = "Pago inicial",
    effectiveApr = "TAE",
    headerBalance = "Saldo",
    headerDate = "Fecha",
    headerInterest = "Interés",
    headerMonth = "#",
    headerPayment = "Pago",
    headerPrincipal = "Principal",
    hideDetails = "Ocultar detalles",
    interest = "Interés",
    invalidData = "Datos inválidos",
    loanAmountSupportingText = "El monto total del préstamo, incluidos los costos adicionales.",
    loanDetails = "Detalles del préstamo",
    paymentSupportingText = "Su pago mensual estimado.",
    paymentComposition = "Composición del pago",
    percentSymbol = "%",
    principal = "Principal",
    ratingBad = "Mal trato",
    ratingExcellent = "Excelente trato",
    ratingFair = "Trato justo",
    ratingGood = "Buen trato",
    ratingPoor = "Mal trato",
    schedule = "Horario",
    showDetails = "Mostrar detalles",
    summaryBad = "Muy desfavorable, evite si es posible.",
    summaryExcellent = "Excelentes condiciones financieras.",
    summaryFair = "Condiciones justas, considere negociar.",
    summaryGood = "Buenas condiciones, estándar para el mercado.",
    summaryPoor = "Malas condiciones, alto costo o tasa.",
    totalPaid = "Total pagado",
    lockTaxRate = "Bloquear tasa de impuestos",
    unlockTaxRate = "Desbloquear tasa de impuestos",
    currencySymbol = "$",
    currency = "Moneda",

    totalCreditAmount = "Monto total del crédito",
    taxAmount = "Monto de impuestos/deducciones",
    netAmountDisbursed = "Monto neto desembolsado", // Изчисляемо поле: totalCreditAmount - всички първоначални такси/данъци

    years = "Años",
    loanTermTotalMonths = "Plazo del préstamo (meses)", // Изчисляемо или входно поле за общия срок

    monthlyInstallment = "Cuota mensual",
    principalInstallment = "Cuota principal",
    otherFees = "Otras tarifas",

    insuranceCost = "Costo del seguro",
    aprc = "Tasa de porcentaje anual de cargos (APRC)",
    totalAmountPayable = "Monto total a pagar",
    prepaidFeeFixed = "Tarifa prepagada fija",
    prepaidFeePercentage = "Tarifa prepagada (porcentaje)",
    months = "Meses",
    description = "Este analizador le ayuda a evaluar si una oferta de préstamo es favorable para usted. A diferencia de las calculadoras estándar, no requiere la entrada de una tasa de interés. En cambio, calcula la APR y el costo total del crédito en función de los pagos y las tarifas, proporcionando una calificación del acuerdo y gráficos detallados.",
    agree = "Acepto",
    information = "Información",
    errorDivisionByZero = "División por cero",
    errorNegativeResult = "Resultado negativo",
    errorRateTooHigh = "Tasa demasiado alta",
    errorCalculation = "Por favor ingrese datos correctos",
    errorCalculationOverflow = "La TAE es demasiado alta, desbordamiento de cálculo.",
    errorTotalPaymentIsLessThanLoanAmount = "El monto recibido es menor que el monto del préstamo.",

    close = "Cerrar",
    hi = "Hola",
    guest = "Invitado",
    account = "Cuenta",
    signInWithGoogle = "Iniciar sesión con Google",
    signOut = "Cerrar sesión",
    settings = "Configuración",
    about = "Acerca de",
    privacyPolicy = "Política de privacidad",
    termsOfService = "Términos de servicio",

    language = "Idioma",
    theme = "Tema",
    light = "Claro",
    dark = "Oscuro",
    system = "Sistema",
    toggleExpand = "Expandir/Contraer",
)
